import { createReducer } from 'redux-act';

import {
    sidebarToggleOpen,
    sidebarToggleClose
} from 'actions/sidebar/toggle';

const defaultState = {
    open: true
};

const sidebarToggle = createReducer({
    [sidebarToggleOpen]: (state) => ({
        ...state,
        open: true
    }),
    [sidebarToggleClose]: (state) => ({
        ...state,
        open: false
    }),
}, defaultState);

export default sidebarToggle;



// WEBPACK FOOTER //
// ./resources/assets/reducers/sidebar/index.js